export default "__VITE_ASSET__Dvi2vFx0__"